import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import  { PRODUCT_API, LATEST_API, ALL_PRODUCTS_API, 
  FAVORITES_API, NOTIFICATIONS_API, IMAGE_BASE_URL, BASE_URL } from "./apiurls";
import { NavLink } from "react-router-dom"; 
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// navigate not used currently, kept as requested

import {
  addItemToCart,
  changeItemAmount,
  deleteItemFromCart
} from "../redux/winesSlice";

import "./ShopsItem.css";

/* ================= STAR RATING ================= */

const StarRating = ({ raiting, max = 5 }) => {
  const percentage = Math.min((raiting / max) * 100, 100);

  return (
    <div className="star-rating">
      <div className="stars-outer">
        ★★★★★
        <div className="stars-inner" style={{ width: `${percentage}%` }}>
          ★★★★★
        </div>
      </div>
      <span className="rating-text">
        {raiting.toFixed(1)}/{max}
      </span>
    </div>
  );
};

/* ================= MAIN COMPONENT ================= */

function ShopsItem({ 
  selectedSiteId,
  selectedCategoryId,
  allCategories = [],
  selectedShops = [],
  mlFilter = { sizes: [], prices: [] },
  nearbyShops,
  searchKeyword,
  favoriteIds = [],
  isNotificationPage = false,
  notificationIds = []
}) {

  const [itemAmount, setItemAmount] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(null);
const [showLoginMessage, setLoginMessage]=useState(false);
const isLoggedIn=localStorage.getItem("isLoggedIn")==="true";
const [productData, setProductData] = useState([]);
const [loading, setLoading] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [favorites, setFavorites] = useState([]);
useEffect(() => {
  const fetchFavorites = async () => {
    try {
      const userMobile = localStorage.getItem("userMobile");
      if (!userMobile) return;

      const response = await fetch(FAVORITES_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "list",
          user_mobile: userMobile
        })
      });

      const data = await response.json();
      console.log("Favorites List:", data);

      setFavorites(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Favorites Fetch Error:", err);
    }
  };

  if (isLoggedIn) {
    fetchFavorites();
  }
}, [isLoggedIn]);
const [notifLoading, setNotifLoading] = useState(false);

const [notificationIdsState, setNotificationIdsState] = useState([]);

useEffect(() => {
  if (isNotificationPage) {
    setNotificationIdsState(notificationIds || []);
  }
}, [notificationIds, isNotificationPage]);

  const itemsInCart = useSelector(state => state.wines.cart);
  const dispatch = useDispatch();

  const handleAddToCart = (newItem) => {
    if (itemsInCart.length === 0) {
      dispatch(addItemToCart(newItem));
      return;
    }

    const existingShop = itemsInCart[0]?.item?.shop;
    const newShop = newItem.item.shop;

    if (existingShop !== newShop) {
      // 🚨 Different shop detected
      setShopConflict(existingShop);
      setPendingItem(newItem);
      return;
    }

    dispatch(addItemToCart(newItem));
  };

  const navigate = useNavigate();
  const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const currentSiteId =
    selectedSiteId ||
    new URLSearchParams(window.location.search).get("site_id");

    const mode = queryParams.get("mode");
    const isAddMorePage = mode === "addmore";

const [shopConflict, setShopConflict] = useState(null);
const [pendingItem, setPendingItem] = useState(null);

const catIdFromUrl = queryParams.get("cat_id");
const bmIdFromUrl = queryParams.get("bm_id");
const isFavoritesPage = location.pathname === "/favorite-brands"; 

const showStockLimit = () => {
    alert("No more items available");
  };
const toggleFavorite = async (product) => {
  try {
    const userMobile = localStorage.getItem("userMobile");
    if (!userMobile) return;

    const favObj = favorites.find(
      f => String(f.bm_id) === String(product.bm_id)
    );

    // ❤️ DELETE
    if (favObj) {
      const response = await fetch(FAVORITES_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "delete",
          id: favObj.id
        })
      });

      const data = await response.json();
      console.log("DELETE Favorite Response:", data);

      setFavorites(prev =>
        prev.filter(f => f.id !== favObj.id)
      );
    }

    // 🤍 ADD
    else {
      const response = await fetch(FAVORITES_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        action: "add",
        user_mobile: userMobile,
        bm_id: product.bm_id
      })
    });

  const data = await response.json();
  console.log("ADD Favorite Response:", data);

  // Refresh favorites from backend
  const listResponse = await fetch(FAVORITES_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      action: "list",
      user_mobile: userMobile
    })
  });

  const updatedFavorites = await listResponse.json();

  setFavorites(Array.isArray(updatedFavorites) ? updatedFavorites : []);
}

  } catch (error) {
    console.error("Favorite Toggle Error:", error);
  }
};
const handleNotifyMe = async (product) => {
  try {
    const userMobile = localStorage.getItem("userMobile");

    if (!userMobile) {
      setLoginMessage(true);
      return;
    }

    // 🔥 Create payload object
    const payload = {
      action: "add",
      user_mobile: userMobile,
      brand_id: product.bm_id,
      site_id: product.site_id
    };

    // ✅ LOG REQUEST BODY
    console.log("Notify API Request:", payload);

    const response = await fetch(NOTIFICATIONS_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    // ✅ LOG RESPONSE
    console.log("Notify API Response:", data);

    if (data?.status === 1) {
      alert(data?.msg || "You will be notified when this brand is back in stock.");
    } 
    else if (data?.status === 0) {
      alert(data?.msg || "You have already registered for notification.");
    } 
    else {
      alert("Notification request failed.");
    }

  } catch (error) {
    console.error("Notify Error:", error);
    alert("Something went wrong. Please try again.");
  }
};
const handleDeleteNotification = async (product) => {
  try {
    const notif = notificationIdsState.find(
      n =>
        String(n.brand_id) === String(product.bm_id) &&
        String(n.site_id) === String(product.site_id)
    );

    if (!notif) {
      alert("Notification not found");
      return;
    }

    const payload = {
      action: "delete",
      id: notif.id
    };

    console.log("DELETE NOTIFICATION:", payload);

    const res = await fetch(NOTIFICATIONS_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    console.log("Delete Response:", data);

    if (data?.status === 1) {
      alert("Notification removed");

      setNotificationIdsState(prev =>
        prev.filter(n => n.id !== notif.id)
      );

    } else {
      alert(data?.msg || "Delete failed");
    }

  } catch (err) {
    console.error("Delete notification error:", err);
  }
};

const handleAddMore = (product) => {
  console.log("Navigating to:", `/shopitem?mode=addmore&site_id=${product.site_id}&cat_id=${product.cat_id}&bm_id=${product.bm_id}`);
  navigate(
    `/shopitem?mode=addmore&site_id=${product.site_id}&cat_id=${product.cat_id}&bm_id=${product.bm_id}`
  );
};

const handleInStockCheck = (product) => {

  navigate(
    `/products?cat_id=${product.cat_id}&bm_id=${product.bm_id}`
  );

};
 const confirmReplaceCart = () => {
  // 🗑 remove all existing cart items
  itemsInCart.forEach(item => {
    dispatch(deleteItemFromCart(item.item.id));
  });

  // ➕ add new item
  if (pendingItem) {
    dispatch(addItemToCart(pendingItem));
  }

  setShopConflict(null);
  setPendingItem(null);
};
  useEffect(() => {
    // ❌ item DOES NOT EXIST
    // ❌ shared state cannot work for mapped lists

    /*
    const cartItem = itemsInCart.find(v => v.item.id === item.id);

    if (cartItem) {
      setItemAmount(cartItem.amount);
      setCurrentPrice(cartItem.amount * item.price);
    } else {
      setItemAmount(0);
      setCurrentPrice(null);
    }
    */
  }, [itemsInCart]);

  /* ================= FETCH PRODUCTS ================= */

useEffect(() => {
  async function fetchProducts() {
    setLoading(true);

    try {// ✅ NOTIFICATIONS PAGE

      // ✅ FAVORITES PAGE
      if (isFavoritesPage) {

        const response = await fetch(ALL_PRODUCTS_API);
        const data = await response.json();

        const formatted = Array.isArray(data)
          ? data.map(p => ({
              ...p,
              id: `${p.bm_id}_${p.site_id}`
            }))
          : [];

        const favProducts = formatted.filter(p =>
          favoriteIds.includes(String(p.bm_id))
        );

        setProductData(favProducts);
        return;
      }
      /* ================= NOTIFICATION PAGE ================= */

if (isNotificationPage && notificationIdsState.length > 0) {

  const formatted = notificationIdsState.map(n => ({
    id: `${n.brand_id}_${n.site_id}`,
    bm_id: n.brand_id,
    site_id: n.site_id,
    brand_nm: n.brand_nm,
    cat_id: n.cat_id,
    cat_name: n.cat_name,
    shop: n.shop_nm,
    shopAdd: n.shopAdd,
    thumb: n.thumb,
    group: n.group, 
    stk_q: "0",
    stk_p: "0",
    stk_n: "0",
    rateq: "0",
    ratep: "0",
    raten: "0",
    sizeq: "750",
    sizep: "375",
    sizen: "180"
  }));

  setProductData(formatted);
  setLoading(false);
  return;
}

      // ✅ ADD MORE PAGE
if (currentSiteId) {

  console.log("currentSiteId =", currentSiteId);

const response = await fetch(
    `https://gitstool.in/liquor/shop_app/addmore_product.php?site_id=${currentSiteId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        site_id: currentSiteId
      })
    }
  );

  const data = await response.json();

  console.log(
  "Contains selected site?",
  data.some(p => String(p.site_id) === String(currentSiteId))
);

  console.log("Received:", data);
  console.log("Returned site_ids:", data.map(x => x.site_id));

  const filteredData = Array.isArray(data)
  ? data.filter(product => {

      const sameShop =
        String(product.site_id) === String(currentSiteId);

      const sameCategory =
        !selectedCategoryId ||
        String(product.cat_id) === String(selectedCategoryId);

      return sameShop && sameCategory;

    })
  : [];

console.log("Filtered products:", filteredData);

setProductData(
  filteredData.map(p => ({
    ...p,
    id: `${p.bm_id}_${p.site_id}`
  }))
);

console.log("Selected site:", currentSiteId);
console.log(
  "Filtered site_ids:",
  filteredData.map(p => p.site_id)
);

  return;
}

// ✅ NORMAL PAGE
if (!catIdFromUrl || !bmIdFromUrl) return;

const response = await fetch(
  `${BASE_URL}product_shop.php?cat_id=${catIdFromUrl}&bm_id=${bmIdFromUrl}`
);

const data = await response.json();

setProductData(
  Array.isArray(data)
    ? data.map(p => ({
        ...p,
        id: `${p.bm_id}_${p.site_id}`
      }))
    : []
);

    } catch (error) {
      console.error("Product fetch error:", error);
      setProductData([]);
    } finally {
      setLoading(false);
    }
  }

  fetchProducts();

}, [
  currentSiteId,
  selectedCategoryId,
  catIdFromUrl,
  bmIdFromUrl,
  isFavoritesPage,
  isNotificationPage,
  notificationIdsState
]);

  /* ================= CART FUNCTIONS ================= */

  // ❌ item DOES NOT EXIST
  // ❌ replaced by inline dispatch per product

  /*
  function productSelected() {
    const itemInCart = {
      item: item,
      amount: 1,
    };
    dispatch(addItemToCart(itemInCart));
  }

  function increaseItemAmount() {
    const amount = itemAmount + 1;
    dispatch(changeItemAmount({ currentItemId: item.id, currentAmount: amount }));
  }

  function decreaseItemAmount() {
    const amount = itemAmount - 1;
    dispatch(changeItemAmount({ currentItemId: item.id, currentAmount: amount }));
    if (amount === 0) {
      dispatch(deleteItemFromCart(item.id));
    }
  }
  */
 


  /* ================= RENDER ================= */

  const memoizeedRenderResult = useMemo(() => {
    let filteredProducts = [...productData];

  /* ================= NOTIFICATION FILTER ================= */

console.log("Notification IDs state:", notificationIdsState);
console.log("Products before notification filter:", filteredProducts.map(p => ({
  bm_id: p.bm_id,
  site_id: p.site_id,
  brand_nm: p.brand_nm,
  shop: p.shop,
  cat_id:p.cat_id,
})));
if (isNotificationPage) {
  const allPairs = productData.map(p =>
    `${p.bm_id}_${p.site_id}`
  );

  console.log("All product pairs:", allPairs);
}

if (isNotificationPage && notifLoading) {
  return <p style={{textAlign:"center", color:"white"}}>Loading notifications...</p>;
}
if (isNotificationPage) {
  console.log("After notification filter:", filteredProducts.map(p => ({
    bm_id: p.bm_id,
    site_id: p.site_id,
    brand_nm: p.brand_nm,
    shop: p.shop
  })));
}

  if (searchKeyword?.trim()) {
  const key = searchKeyword.toLowerCase();
  filteredProducts = filteredProducts.filter(p =>
    p.brand_nm?.toLowerCase().includes(key) ||
    p.cat_name?.toLowerCase().includes(key) ||
    p.shop?.toLowerCase().includes(key)
  );
}

/* CATEGORY / SHOP FILTER — AFTER */
/* ================= MULTI SHOP FILTER ================= */

if (Array.isArray(selectedShops) && selectedShops.length > 0) {
  const normalizedShops = selectedShops.map(shop =>
    String(shop).trim().toLowerCase()
  );

  filteredProducts = filteredProducts.filter(product =>
    product.shop &&
    normalizedShops.includes(
      String(product.shop).trim().toLowerCase()
    )
  );
}
  
/* ================= MULTI SIZE + PRICE FILTER ================= */

const selectedSizes = Array.isArray(mlFilter?.sizes)
  ? mlFilter.sizes
  : [];

const selectedPrices = Array.isArray(mlFilter?.prices)
  ? mlFilter.prices
  : [];


/* ---------- SIZE + PRICE FILTER ---------- */

if (selectedSizes.length > 0 || selectedPrices.length > 0) {

  filteredProducts = filteredProducts.filter(product => {

    const sizeOptions = [
      {
        size: `${product.sizeq}ML`,
        rate: Number(product.rateq),
        stock: Number(product.stk_q)
      },
      {
        size: `${product.sizep}ML`,
        rate: Number(product.ratep),
        stock: Number(product.stk_p)
      },
      {
        size: `${product.sizen}ML`,
        rate: Number(product.raten),
        stock: Number(product.stk_n)
      }
    ];

    return sizeOptions.some(option => {

      /* ----- SIZE MATCH ----- */

      const sizeMatches =
        selectedSizes.length === 0 ||
        selectedSizes.includes(option.size);


      /* ----- PRICE MATCH ----- */

      let priceMatches = true;

      if (selectedPrices.length > 0) {

        priceMatches = selectedPrices.some(range => {

          const price = option.rate;

          switch (range) {

            case "0-499":
              return price >= 0 && price <= 499;

            case "500-999":
              return price >= 500 && price <= 999;

            case "1000-1499":
              return price >= 1000 && price <= 1499;

            case "1500-1999":
              return price >= 1500 && price <= 1999;

            case "2000+":
              return price >= 2000;

            default:
              return false;
          }

        });

      }


      /* ----- STOCK MATCH ----- */

      const stockMatches = option.stock > 0;


      return sizeMatches && priceMatches && stockMatches;

    });

  });

}
/* ================= SORT BY DISTANCE (NEAREST FIRST) ================= */

if (Array.isArray(nearbyShops?.shops)) {
  filteredProducts = filteredProducts.sort((a, b) => {
    const shopA = nearbyShops.shops.find(
      s => String(s.site_id) === String(a.site_id)
    );

    const shopB = nearbyShops.shops.find(
      s => String(s.site_id) === String(b.site_id)
    );

    const distA = shopA ? Number(shopA.distance_km) : Infinity;
    const distB = shopB ? Number(shopB.distance_km) : Infinity;

    return distA - distB; // nearest first
  });
}
    if (loading) {
  return <p style={{ textAlign: "center", color:"white" }}>Loading products...</p>;
}
  
    return (
      <>
        {filteredProducts.map(product => {

const normalize = v => v?.trim().toLowerCase();

const shopInfo = Array.isArray(nearbyShops?.shops)
  ? nearbyShops.shops.find(
      s =>
        String(s.site_id) === String(product.site_id)
    )
  : null;
const favObj = favorites.find(
  f => String(f.bm_id) === String(product.bm_id)
);

const isFav = !!favObj;

console.log({
  brand: product.brand_nm,
  bm_id: product.bm_id,
  isFav,
  favoriteBmIds: favorites.map(f => f.bm_id)
});

const totalAmount = itemsInCart
  .filter(v => v.item.id.startsWith(product.id + "_"))
  .reduce((sum, v) => sum + v.amount, 0);
          // Each product reads ITS OWN cart state
          const cartItem = itemsInCart.find(
            v => v.item.id === product.id
          );

          const amount = cartItem ? cartItem.amount : 0;
          const price = cartItem
            ? cartItem.amount * Number(product.price || 0)
            : 0;

          return (
              
  <div key={product.id} className="product-wrapper-shop">

    {/* Product Name
    <div className="item-description-title">
      <h3>{product.brand_nm}</h3>
    </div> */}

    {/* Item Card */}
    <div className="item-card-shop">
              

              <div className="item-img-block-shop">
                <img
  className="item-img-shop"
  src={`${IMAGE_BASE_URL}${
    product.p_images?.length
    ? product.p_images[0]
    : product.thumb
  }`}
  title={product.brand_nm}
  alt={product.brand_nm}
  onClick={() => setSelectedProduct(product)}
  style={{ cursor: "pointer" }}
/>  <div className="item-description-title-shop">
      <p>{product.brand_nm}</p>
    </div>  </div>  {!isNotificationPage && (<>
{selectedProduct?.id === product.id && (
  <div className="fullscreen-modal-shop" onClick={() => setSelectedProduct(null)}                                                        >
    <div className="modal-content-shop" onClick={e => e.stopPropagation()} >

      <span
        className="modal-close-shop"
       onClick={() => setSelectedProduct(null)}
      >                                                                                                              
        ✕
      </span>

      <div className="modal-inner-shop">
        <div className="modal-image-block-shop">
          
<div
  className={`fav-icon-shop ${isFav ? "fav-active-shop" : ""}`}
  onClick={(e) => {
    e.stopPropagation();
      if (!isLoggedIn) {
    setLoginMessage(true);
    return;
  }

   toggleFavorite(product);
  }}
>
  {isFav ? "❤️" : "🤍"}
</div>
          <img
            src={`${IMAGE_BASE_URL}${selectedProduct.thumb}`}
            alt={selectedProduct.brand_nm}
            className="modal-image-shop"
          />
        </div>

        <div className="modal-info-block-shop">

          <h2 style={{marginTop:"20px"}} > {selectedProduct.brand_nm}</h2>
          
          <p style={{marginTop:"-10px"}}>{selectedProduct.cat_name} • {selectedProduct.shop}</p>
          

          <div className="modal-description-shop">
             
  <span>{product.sizeq}ML</span>
  <span>{product.sizep}ML</span>
  <span>{product.sizen}ML</span>
</div>
          <div className="modal-description-shop">
   
  <span>{product.stk_q}</span>
  <span>{product.stk_p}</span>
  <span>{product.stk_n}</span>
</div>
<div className="modal-description-shop">
   
  <span>₹{product.rateq}</span>
  <span>₹{product.ratep}</span>
  <span>₹{product.raten}</span>
</div>
<h3 style={{marginTop:"20px"}}> Description</h3>
          <p className="desc">{selectedProduct.p_desc} </p>
          {/* Notify Me button */}
{["stk_q", "stk_p", "stk_n"].some(key => Number(selectedProduct[key]) === 0) && (
  <div
    className="notify-shop"
    style={{ mcursor: "pointer" }}
    onClick={() => handleNotifyMe(selectedProduct)}
  >
    Notify Me
  </div>
)}

          
        </div>
      </div>

    </div>
  </div>
)} </>)}

             

              <div className="item-raiting-block-shop">
                {Number(product.p_rating || 0).toFixed(1)}
              </div>
               <div className="item-name-shop">
                {product.cat_name}
              </div>
              

              <div
                className={
                  totalAmount > 0
                    ? "item-sticker-shop"
                    : "item-sticker_hidden-shop"
                }
              >
                {totalAmount}
              </div>

              <div className="item-description-block-shop">
                <div className="shop-row-shop">
                  <div className="item-controls-par-shop">
                        <span className="product-group">{product.group}</span>-{product.shop}</div><br></br>
                        {!isNotificationPage && (
                      <div className="item-controls-par1-shop">
  {shopInfo
    ? `${Number(shopInfo.distance_km).toFixed(2)} (KM)`
    : "Distance unavailable"}
</div>)}
</div>
                      <p className="shop-add-par-shop">
                        {product.shopAdd}
                      </p><br></br>
             {/*   <h2
  className="item-description-title"
  ref={el => {
    if (!el) return;

    let fontSize = 18;
    el.style.fontSize = fontSize + "px";

    while (el.scrollWidth > el.clientWidth && fontSize > 10) {
      fontSize -= 0.5;
      el.style.fontSize = fontSize + "px";
    }
  }}
>
  {product.brand_nm}
</h2>*/}


               {/*div className="item-description-par">
                  {product.sizeq}ML • {product.sizep}ML • {product.sizen}ML
                </div>*/}
                {!isNotificationPage && (
                   <>
               {/* <div className="item-description-par">
            
  <span>{product.sizeq}ML</span>
  <span>{product.sizep}ML</span>
  <span>{product.sizen}ML</span>
</div>
 <div className="item-description-par">
  
  <span>{product.stk_q}</span>
  <span>{product.stk_p}</span>
  <span>{product.stk_n}</span>
</div>
<div className="item-description-par">
   
  <span>₹{product.rateq}</span>
  <span>₹{product.ratep}</span>
  <span>₹{product.raten}</span>
</div>*/}
<div className="item-description-grid-shop">

  <span></span>
  <span className="size-pill-shop">{product.sizeq}ML</span>
  <span className="size-pill-shop">{product.sizep}ML</span>
  <span className="size-pill-shop">{product.sizen}ML</span>

  <span className="label-shop">Stock:</span>
  <span>{product.stk_q}</span>
  <span>{product.stk_p}</span>
  <span>{product.stk_n}</span>

  <span className="label-shop">MRP:</span>
  <span>₹{product.rateq}</span>
  <span>₹{product.ratep}</span>
  <span>₹{product.raten}</span>

</div></>
)}<br></br>

             {/* div className="rating-row">
                  <StarRating raiting={Number(product.p_rating || 0)} />
                </div>*/}
{isNotificationPage ? (

  <div className="notification-actions-shop">
    <button
      className="notify-delete-btn-shop"
      onClick={() => handleDeleteNotification(product)}
    >
       🗑 Delete
    </button>

    <button
      className="notify-stock-btn-shop"
      onClick={() => handleInStockCheck(product)}
    >
      ✔ In Stock
    </button>
  </div>

) : (

        <div className="item-actions-shop">
          <div className="size-actions-shop">

  {[
    { label: product.sizeq + "ML", key: "Q" },
    { label: product.sizep + "ML", key: "P" },
    { label: product.sizen + "ML", key: "N" }
  ].map(size => {

    const sizeId = `${product.id}_${size.key}`;

    const sizeCartItem = itemsInCart.find(
      v => v.item.id === sizeId
    );

    const sizeAmount = sizeCartItem ? sizeCartItem.amount : 0;
const stock =
  size.key === "Q" ? Number(product.stk_q) :
  size.key === "P" ? Number(product.stk_p) :
  Number(product.stk_n);
 
    return (
      <div
        key={sizeId}
        className={`item-controls-btn-shop ${stock === 0 ? "btn-disabled-shop" : ""}`}
        style={{ flex: 1 }}
      >
        
        {sizeAmount === 0 ? (
          <span
            
    onClick={() => {
       if (stock === 0 ) return;
       
    handleAddToCart({
  item: {
    id: sizeId,
    site_id: product.site_id,
cat_id: product.cat_id,
    bm_id: product.bm_id,
    shop: product.shop,
    group: product.group,
    shopAdd: product.shopAdd,
    brand_nm: product.brand_nm,
    cat_name: product.cat_name,
    thumb: product.thumb,
    selectedRate:
      size.key === "Q" ? product.rateq :
      size.key === "P" ? product.ratep :
      product.raten,
    selectedStock:
      size.key === "Q" ? product.stk_q :
      size.key === "P" ? product.stk_p :
      product.stk_n,
    selectedSize: size.label
  },
  amount: 1
});
            }}
          >
            {stock === 0 ? "Out of Stock" : "Add +"}
          </span>
        ) : (
          <div className="qty-controls-shop">
            <span
              onClick={e => {
              e.stopPropagation();
                dispatch(
                  changeItemAmount({
                    currentItemId: sizeId,
                    currentAmount: sizeAmount - 1
                  })
                )
              }}
            >
              -
            </span>

            <span className="qty-shop">{sizeAmount}</span>

            <span
              onClick={e => {
              e.stopPropagation();

              if (sizeAmount >= stock) {
                showStockLimit(); // 🔔 popup
                return;
              }
                dispatch(
                  changeItemAmount({
                    currentItemId: sizeId,
                    currentAmount: sizeAmount + 1
                  })
                )
              }}
            >
              +
            </span>
          </div>
        )}
      </div>
    );
  })} 
</div>

{!isAddMorePage && (
<div className="add-more-wrapper-shop">
        <button
    className="add-more-btn-shop"
    onClick={() => handleAddMore(product)}
>
    Add More
</button>
</div>
)}
</div>
)}
              </div>
            </div></div>
          );
        })}
        
      </>
    );
  }, [
  loading,
  productData,
  itemsInCart,
  selectedCategoryId,
  dispatch,
  selectedShops,
  mlFilter,
  nearbyShops,
  searchKeyword,
  selectedProduct,
  favorites,
  isNotificationPage,
  notificationIdsState
]);

 return (
  <>
    {memoizeedRenderResult}
    {shopConflict && (
  <div className="cart-conflict-bar-shop">
    <div className="conflict-content-shop">
      <span>
        Remove items from {shopConflict} to add items from another shop?
      </span>

      <div className="conflict-actions-shop">
        <button onClick={() => setShopConflict(null)}>Cancel</button>
        <button onClick={confirmReplaceCart}>Remove & Add</button>
      </div>
    </div>
  </div>
)}

    {showLoginMessage && (
      <div
        className="login-warning-overlay-shop"
        onClick={() => setLoginMessage(false)}
      >
        <div
          className="login-warning-box-shop"
          onClick={(e) => e.stopPropagation()}
        >
          <p>Please login to add items in favorites</p>
          <button onClick={() => setLoginMessage(false)}>
            OK
          </button>
        </div>
      </div>
    )}
  </>
);
}

/* ================= PROPTYPES ================= */

// ❗ item prop no longer used
// ❗ kept only because you asked not to remove anything
ShopsItem.propTypes = {
  item: PropTypes.shape({
    alcohol: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    grapeSort: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    imgBig: PropTypes.string.isRequired,
    imgSmall: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    production: PropTypes.string.isRequired,
    raiting: PropTypes.number.isRequired,
    region: PropTypes.array.isRequired,
    sugar: PropTypes.string.isRequired,
    volume: PropTypes.number.isRequired
  })
};

export default ShopsItem;